const gp = "{GP}";
const Firma = ({ bg, logo }) => {

    return (
        <div className="w-100">
            <span
                className={`${bg === 'dark' ? 'text-white' : 'text-primary'}`}
            >
                {gp}
            </span>
            {!logo ? <span className={`${bg === 'dark' ? 'text-white' : null}`}>Developer</span> : null}
        </div>
    )

}

export default Firma;